import { sendXray } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';

import { emitAnalyticEvent } from '../experimentAnalytic';
import { AnalyticEventNames } from '../experimentAnalytic/eventNames';
import { getChangeDesignUrl } from './getChangeDesignUrl';

// tempexp_17340-start

export const changeDesignBreadcrumbs = () => {
    emitAnalyticEvent(AnalyticEventNames.TOOLBAR_ITEM_CLICK_BRAND_PAGE);
    sendXray('toolbar_item-click_brand_page');
    const url = getChangeDesignUrl();
    url.searchParams.append('source', 'breadcrumbs');
    opener(url.toString());
};

// tempexp_17340-end
